import type { StaffMe } from "@payezy/api-client/admin";
import { getStaffMeOptions } from "@payezy/api-client/admin/query";
import { useSuspenseQuery } from "@tanstack/react-query";

export type Tone = "neutral" | "success" | "warning" | "danger" | "info";

export function useStaff(): StaffMe & { can: (perm: string) => boolean } {
  const me = useSuspenseQuery({ ...getStaffMeOptions(), refetchInterval: 60_000 }).data;
  return { ...me, can: (perm) => me.permissions.includes(perm) };
}

export const orgStatusTone: Record<string, Tone> = {
  kyc_required: "warning",
  kyc_pending: "info",
  active: "success",
  restricted: "warning",
  suspended: "danger",
  closed: "neutral",
};

export function paymentTone(status: string): Tone {
  switch (status) {
    case "completed":
      return "success";
    case "failed":
    case "returned":
    case "canceled":
    case "rejected":
      return "danger";
    case "pending_approval":
    case "refunded":
      return "warning";
    default:
      return "info";
  }
}

export const actionTone: Record<string, Tone> = {
  pending_approval: "warning",
  approved: "info",
  executed: "success",
  rejected: "neutral",
  failed: "danger",
};

export const breakKindLabel: Record<string, string> = {
  balance_mismatch: "Balance mismatch",
  unmatched_partner_transfer: "Unmatched partner transfer",
  stuck_leg: "Stuck payment leg",
  status_mismatch: "Status mismatch",
};

export const healthTone: Record<string, Tone> = { up: "success", degraded: "warning", down: "danger" };

export const onboardingTone: Record<string, Tone> = {
  draft: "neutral",
  submitted: "info",
  in_review: "info",
  documents_required: "warning",
  approved: "success",
  rejected: "danger",
};
